"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TeachingPopoverCarouselPageCount", {
    enumerable: true,
    get: function() {
        return TeachingPopoverCarouselPageCount;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTeachingPopoverCarouselPageCount = require("./useTeachingPopoverCarouselPageCount");
const _renderTeachingPopoverCarouselPageCount = require("./renderTeachingPopoverCarouselPageCount");
const _useTeachingPopoverCarouselPageCountStylesstyles = require("./useTeachingPopoverCarouselPageCountStyles.styles");
const TeachingPopoverCarouselPageCount = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTeachingPopoverCarouselPageCount.useTeachingPopoverCarouselPageCount_unstable)(props, ref);
    (0, _useTeachingPopoverCarouselPageCountStylesstyles.useTeachingPopoverCarouselPageCountStyles_unstable)(state);
    return (0, _renderTeachingPopoverCarouselPageCount.renderTeachingPopoverCarouselPageCount_unstable)(state);
});
TeachingPopoverCarouselPageCount.displayName = 'TeachingPopoverCarouselPageCount';
